// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"107":"2d5eaf33","161":"e2d2149b","533":"53ab4422","540":"91206b2f","552":"ea37ac69","864":"91206b2f"}[chunkId] + ".css";
};